import { i18n } from '@/i18n';
import { normalizeSiteLocale, type SiteLocale } from '@/lib/site-locale';

export type LegalPageId = 'terms' | 'privacy' | 'cookie-policy';

type MarkdownLoader = () => Promise<{ default: string }>;

const legalMarkdownByLocale: Record<SiteLocale, Record<LegalPageId, MarkdownLoader>> = {
  en: {
    terms: () => import('@/content/legal/en/terms.md?raw'),
    privacy: () => import('@/content/legal/en/privacy.md?raw'),
    'cookie-policy': () => import('@/content/legal/en/cookie-policy.md?raw'),
  },
  ja: {
    terms: () => import('@/content/legal/ja/terms.md?raw'),
    privacy: () => import('@/content/legal/ja/privacy.md?raw'),
    'cookie-policy': () => import('@/content/legal/ja/cookie-policy.md?raw'),
  },
  ko: {
    terms: () => import('@/content/legal/ko/terms.md?raw'),
    privacy: () => import('@/content/legal/ko/privacy.md?raw'),
    'cookie-policy': () => import('@/content/legal/ko/cookie-policy.md?raw'),
  },
  es: {
    terms: () => import('@/content/legal/es/terms.md?raw'),
    privacy: () => import('@/content/legal/es/privacy.md?raw'),
    'cookie-policy': () => import('@/content/legal/es/cookie-policy.md?raw'),
  },
};

export async function loadLegalMarkdown(pageId: LegalPageId): Promise<string> {
  const locale = normalizeSiteLocale(i18n.locale) ?? 'en';
  const mod = await legalMarkdownByLocale[locale][pageId]();
  return mod.default;
}

export const LEGAL_COOKIE_CONSENT_MARKER = '<!-- LEGAL_COOKIE_CONSENT_BUTTON -->';
